import { render, staticRenderFns } from "./patientInfo.vue?vue&type=template&id=d57f8c80&scoped=true"
import script from "./patientInfo.vue?vue&type=script&lang=js"
export * from "./patientInfo.vue?vue&type=script&lang=js"
import style0 from "./patientInfo.vue?vue&type=style&index=0&id=d57f8c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57f8c80",
  null
  
)

export default component.exports